/*
  DON'T import this file directly, import src/graphql/index.js into your deps
  When you need to modify a query or fragment, modify the .graphql files - NOT the __generated__ files
  Each time you modify a GraphQL file, the node_modules/.cache/babel-loader folder must be cleared for the changes to take effect
*/

import { type GraphQLRequestParams } from '../types';

import { Templates } from './__generated__';

interface IAddSeedToStationRequestVariables {
  seedId: string;
  stationId: string;
}

const addSeedToStation = (
  requestVariables: IAddSeedToStationRequestVariables,
): GraphQLRequestParams<IAddSeedToStationRequestVariables> => {
  const { stationId, seedId } = requestVariables;
  return {
    query: Templates.AddSeedToStation,
    operationKeyName: 'ADD_SEED_TO_STATION',
    variables: { stationId, seedId },
  };
};

interface IDeleteSeedFromStationRequestVariables {
  seedId: string;
  stationId: string;
}

const deleteSeedFromStation = (
  requestVariables: IDeleteSeedFromStationRequestVariables,
): GraphQLRequestParams<IDeleteSeedFromStationRequestVariables> => {
  const { stationId, seedId } = requestVariables;
  return {
    query: Templates.DeleteSeedFromStation,
    operationKeyName: 'DELETE_SEED_FROM_STATION',
    variables: { stationId, seedId },
  };
};

interface IUpdateStationDetailsRequestVariables {
  description: string;
  enableArtistMessages?: boolean;
  name: string;
  stationId: string;
}

const updateStationDetails = (
  requestVariables: IUpdateStationDetailsRequestVariables,
  actionParams: unknown,
): GraphQLRequestParams<IUpdateStationDetailsRequestVariables> => {
  const { stationId, name, description, enableArtistMessages } = requestVariables;
  return {
    query: Templates.UpdateStationDetails,
    operationKeyName: 'UPDATE_STATION_DETAILS',
    variables: { stationId, name, description, enableArtistMessages },
    actionParams,
  };
};

interface IRemoveFromLibraryRequestVariables {
  pandoraId: string;
}

const removeFromLibrary = (
  requestVariables: IRemoveFromLibraryRequestVariables,
): GraphQLRequestParams<IRemoveFromLibraryRequestVariables> => {
  const { pandoraId } = requestVariables;
  return {
    query: Templates.RemoveFromLibrary,
    operationKeyName: 'REMOVE_FROM_LIBRARY',
    variables: { pandoraId },
  };
};

export default {
  addSeedToStation,
  deleteSeedFromStation,
  updateStationDetails,
  removeFromLibrary,
};
